import { Icon } from '@chakra-ui/react';

export default function LensIcon(props) {
  return (
    <Icon
      width='22px'
      height='22px'
      viewBox='0 0 22 22'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.99996 1.91496C4.63931 1.91496 1.91496 4.63931 1.91496 7.99996C1.91496 11.3606 4.63931 14.085 7.99996 14.085C11.3606 14.085 14.085 11.3606 14.085 7.99996C14.085 4.63931 11.3606 1.91496 7.99996 1.91496ZM0.584961 7.99996C0.584961 3.90477 3.90477 0.584961 7.99996 0.584961C12.0952 0.584961 15.415 3.90477 15.415 7.99996C15.415 12.0952 12.0952 15.415 7.99996 15.415C3.90477 15.415 0.584961 12.0952 0.584961 7.99996Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.0512 7.21725C14.0899 6.85203 14.4174 6.5874 14.7827 6.62618C16.1746 6.77399 17.4963 7.31279 18.5949 8.18029C19.6935 9.04778 20.5241 10.2085 20.9907 11.5283C21.4573 12.8481 21.5407 14.2729 21.2314 15.6381C20.9221 17.0033 20.2327 18.2531 19.2429 19.2429C18.2531 20.2327 17.0033 20.9222 15.6381 21.2315C14.2729 21.5408 12.848 21.4573 11.5283 20.9907C10.2085 20.5242 9.04775 19.6936 8.18025 18.595C7.31276 17.4964 6.77396 16.1747 6.62615 14.7827C6.58737 14.4175 6.852 14.09 7.21722 14.0512C7.58244 14.0124 7.90994 14.277 7.94872 14.6423C8.07001 15.7846 8.51217 16.8692 9.22407 17.7707C9.93596 18.6723 10.8885 19.3539 11.9715 19.7368C13.0546 20.1197 14.2239 20.1882 15.3442 19.9343C16.4646 19.6805 17.4902 19.1147 18.3024 18.3025C19.1147 17.4902 19.6805 16.4646 19.9343 15.3443C20.1881 14.2239 20.1196 13.0546 19.7368 11.9716C19.3539 10.8885 18.6723 9.93599 17.7707 9.2241C16.8692 8.5122 15.7845 8.07004 14.6422 7.94875C14.277 7.90997 14.0124 7.58247 14.0512 7.21725Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.9901 9.49006C14.2498 9.23036 14.6708 9.23036 14.9305 9.49006L20.9305 15.4901C21.1902 15.7498 21.1902 16.1708 20.9305 16.4305C20.6708 16.6902 20.2498 16.6902 19.9901 16.4305L13.9901 10.4305C13.7304 10.1708 13.7304 9.74976 13.9901 9.49006Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3026 12.3026C12.5623 12.0429 12.9833 12.0429 13.243 12.3026L19.243 18.3026C19.5027 18.5623 19.5026 18.9832 19.2429 19.2429C18.9832 19.5026 18.5623 19.5027 18.3026 19.243L12.3026 13.243C12.0429 12.9833 12.0429 12.5623 12.3026 12.3026Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.49006 13.9901C9.74976 13.7304 10.1708 13.7304 10.4305 13.9901L16.4305 19.9901C16.6902 20.2498 16.6902 20.6708 16.4305 20.9305C16.1708 21.1902 15.7498 21.1902 15.4901 20.9305L9.49006 14.9305C9.23036 14.6708 9.23036 14.2498 9.49006 13.9901Z'
      />
    </Icon>
  );
}
